var render = function render(_c,_vm){return _c('fragment',[(_vm.props.type === 'danger')?_c('el-tag',{class:_vm.$style['danger'],attrs:{"type":"danger","size":"small"}},[_vm._v(" "+_vm._s(_vm.props.text)+" ")]):(_vm.props.type === 'warning')?_c('el-tag',{class:_vm.$style['warning'],attrs:{"size":"small"}},[_vm._v(" "+_vm._s(_vm.props.text)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }